import styled, { css } from 'styled-components'

export const PostContentTitle = styled.div`
  margin: ${({ theme }) => theme.rem(24, 0)};
`
